export default __webpack_public_path__ + "4da86141b0b0bbaf761431ebb7082802.png";